import { removeItem } from '../utils/LocalStorageUtil';
import { TOKEN_KEY, USER_DATA_KEY } from '../utils/StorageKeys';
export var authMiddleware = function (store) { return function (next) { return function (action) {
    if (action && action.type !== 'LOGIN_ERROR' && checkError(action)) {
        removeItem(TOKEN_KEY);
        removeItem(USER_DATA_KEY);
    }
    next(action);
}; }; };
export var redirectToLogin = function () {
    window.location.assign('/#/login');
};
var checkError = function (action) {
    if (action && action.code == "ERROR_BAD_CREDENTIALS") {
        return true;
    }
    if (action.error && (action.error.code === 'ERROR_BAD_CREDENTIALS' || action.error.code === 'ERROR_BAD_TOKEN')) {
        return true;
    }
    return false;
};
